import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IGetBookingsCommonResponse } from "libraries/service/resources/booking/interfaces/IGetBookings";

@Component({
    selector: 'booking-fare-opt-history',
    template: `
        <iframe-app-embedder [iframeSrc]="'http://flutter-monorepo-0.3.1-dev.0.afidium.surge.sh/fare-opt-list-app/'"
                             [additionalData]="specificInit">
        </iframe-app-embedder>
    `,
    styles: [`
        iframe-app-embedder {
            height: 300px;
            width: 100%;
        }
    `]
})
export class BookingFareOptHistoryComponent implements OnInit {

    @Input()
    public bookingResult: IGetBookingsCommonResponse;

    @Output()
    public readonly onCardTitleClick: EventEmitter<string> = new EventEmitter();

    public specificInit: { bookingResult: IGetBookingsCommonResponse };

    public ngOnInit(): void {
        this.specificInit = {bookingResult: this.bookingResult};
    }

    public menuToggleCard(): void {
        this.onCardTitleClick.emit('bookingFareOptHistory');
    }

}
